import { rangeWithFallbackBounds } from '../engine/default-handlers';
import { defineFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

const DEFAULT_MIN_FUNDING = 0;
const DEFAULT_MAX_FUNDING = Number.MAX_SAFE_INTEGER;

export const lastFundingAmountDescriptor = defineFilter({
  definition: {
    id: FilterId.LAST_FUNDING_AMOUNT,
    name: 'Last Funding Amount',
    type: FilterType.RANGE,
    min: undefined,
    max: undefined,
    isActive: false,
    isVisible: true,
  },
  handler: rangeWithFallbackBounds(DEFAULT_MIN_FUNDING, DEFAULT_MAX_FUNDING),
});
